import { HStack, Text } from '@chakra-ui/react'
import { OldProductDTO } from 'ecosystem'

const CustomStockLevel = ({ product }: { product: OldProductDTO }) => {
  return (
    <HStack align="center" justify="center" py={2} w="full">
      <Text fontSize="md">Antal i lager</Text>
      <Text align="left" fontSize="md">
        <strong>{product.stockLevel} st.</strong>
      </Text>
    </HStack>
  )
}

export default CustomStockLevel
